import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { CustomMatPaginatorIntl } from './custom-mat-paginator';
import { MatPaginatorIntl } from '@angular/material';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LocalSaveService } from './services/local-save-service.service';
import { ConfigService } from './services/config.service';
import { LoginService } from './services/login.service';
import { routes } from './route.module';
import { AppInterceptor } from './../utils/app-interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ComponentPageTitle } from './page-title/page-title.component';
import { Handle } from './handle';
import { ComponentTabController } from './tab-controller';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { UploadServiceService } from './services/upload-service.service';
import { CustomizerService } from './services/customizer.service';
import { FiltroPaisService } from './home/filtro-pais.service';

// Shared and feature modules
import { SharedModule } from './shared/shared.module';
import { SupervisorModule } from './supervisor/supervisor.module';

// Home components (remain in AppModule - routed under /home)
import { HomeComponent } from './home/home.component';
import { CampanaComponent } from './home/campana/campana.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { CreatecampanaComponent } from './home/createcampana/createcampana.component';
import { ModifyCampanaComponent } from './home/modify-campana/modify-campana.component';
import { CreateScheduleComponent } from './home/create-schedule/create-schedule.component';
import { CreateAlarmaComponent } from './home/create-alarma/create-alarma.component';
import { CreateCriterioComponent } from './home/create-criterio/create-criterio.component';
import { EjeComponent } from './home/eje/eje.component';
import { CreateEjeComponent } from './home/create-eje/create-eje.component';
import { TipologiaComponent } from './home/tipologia/tipologia.component';
import { CreateTipologiaComponent } from './home/create-tipologia/create-tipologia.component';
import { RolComponent } from './home/rol/rol.component';
import { CreateRolComponent } from './home/create-rol/create-rol.component'
import { AgenteComponent } from './home/agente/agente.component';
import { CreateAgenteComponent } from './home/create-agente/create-agente.component';
import { AsignarCampanaComponent } from './home/asignar-campana/asignar-campana.component';
import { CreateCicloComponent } from './home/create-ciclo/create-ciclo.component';
import { ReasignacionModalComponent } from './home/agente/reasignacion-modal/reasignacion-modal.component';
import { ConfiguracionComponent } from './home/configuracion/configuracion.component';
import { RazonAlarmaComponent } from './home/razon-alarma/razon-alarma.component';
import { CreateRazonComponent } from './home/create-razon/create-razon.component';
import { EntrevistaComponent } from './home/entrevista/entrevista.component';
import { CreateEntrevistaComponent } from './home/entrevista/create-entrevista/create-entrevista.component';
import { DistribuidorComponent } from './home/distribuidor/distribuidor.component';
import { CreateDistribuidorComponent } from './home/distribuidor/create-distribuidor/create-distribuidor.component';
import { ClienteDuplicadoComponent } from './home/cliente-duplicado/cliente-duplicado.component';
import { AutorizarCampanaComponent } from './home/autorizar-campana/autorizar-campana.component';
import { DlgCampanaComponent } from './home/autorizar-campana/dlg-campana/dlg-campana.component';
import { DlgCampanaDetailComponent } from './home/autorizar-campana/dlg-campana/dlg-campana-detail/dlg-campana-detail.component';
import { MensajeriaMasivaComponent } from './home/mensajeria-masiva/mensajeria-masiva.component';
import { CreateMensajeriaComponent } from './home/mensajeria-masiva/create-mensajeria/create-mensajeria.component';
import { ConfigBlacklistComponent } from './home/config-blacklist/config-blacklist.component';
import { CreatePruebaComponent } from './home/config-blacklist/create-prueba/create-prueba.component';
import { AreaComponent } from './home/area/area.component';
import { CreateAreaComponent } from './home/area/create-area/create-area.component';
import { AdministradorComponent } from './home/administrador/administrador.component';
import { CreateAdministradorComponent } from './home/administrador/create-administrador/create-administrador.component';
import { DuplicarCampanaComponent } from './home/campana/duplicar-campana/duplicar-campana.component';
import { ScheduleCitasComponent } from './home/schedule-citas/schedule-citas.component';
import { ConfigContrataComponent } from './home/config-contrata/config-contrata.component';
import { CampanaAdminComponent } from './home/campana-admin/campana-admin.component';
import { CreateCampanaComponent } from './home/campana-admin/create-campana/create-campana.component';
import { TipificacionRecolectorComponent } from './home/tipificacion-recolector/tipificacion-recolector.component';
import { CreateTipificacionComponent } from './home/tipificacion-recolector/create-tipificacion/create-tipificacion.component';
import { EquipoRecolectadoComponent } from './home/equipo-recolectado/equipo-recolectado.component';
import { VerImgComponent } from './home/equipo-recolectado/ver-img/ver-img.component';
import { RecolectorEquiposComponent } from './home/recolector-equipos/recolector-equipos.component';
import { CreateRecolectorEquiposComponent } from './home/recolector-equipos/create-recolector-equipos/create-recolector-equipos.component';
import { AdminAgenteComponent } from './home/admin-agente/admin-agente.component';
import { CrudAgenteComponent } from './home/admin-agente/crud-agente/crud-agente.component';
import { EditContratasComponent } from './home/campana-admin/edit-contratas/edit-contratas.component';
import { CitasProgramadasComponent } from './home/citas-programadas/citas-programadas.component';
import { DlgCitaprogramComponent } from './home/citas-programadas/dlg-citaprogram/dlg-citaprogram.component';
import { DlgEditarCuentaComponent } from './home/citas-programadas/dlg-editar-cuenta/dlg-editar-cuenta.component';
import { CitasSuspendidasComponent } from './home/citas-suspendidas/citas-suspendidas.component';
import { DlgFiltersComponent } from './home/campana-admin/dlg-filters/dlg-filters.component';
import { ReporteCitaComponent } from './home/reporte-cita/reporte-cita.component';
import { ReporteFallapersisteComponent } from './home/reporte-fallapersiste/reporte-fallapersiste.component';
import { MapaCitaComponent } from './home/mapa-cita/mapa-cita.component';
import { MapaCitaFiltersComponent } from './home/mapa-cita/mapa-cita-filters/mapa-cita-filters.component';
import { MapaCitaAlarmasTableComponent } from './home/mapa-cita/mapa-cita-alarmas-table/mapa-cita-alarmas-table.component';
import { SupervisorAdminComponent } from './home/supervisor-admin/supervisor-admin.component';
import { CreateSupervisorAdminComponent } from './home/supervisor-admin/create-supervisor-admin/create-supervisor-admin.component';
import { ConfigZonaComponent } from './home/config-zona/config-zona.component';
import { ConfigDistritoComponent } from './home/config-zona/config-distrito/config-distrito.component';
import { ConfigCorregimientoComponent } from './home/config-zona/config-corregimiento/config-corregimiento.component';
import { EdificioComponent } from './home/edificio/edificio.component';
import { CreateEdificioComponent } from './home/edificio/create-edificio/create-edificio.component';
import { MapaTecnicoComponent } from './home/mapa-tecnico/mapa-tecnico.component';
import { MonitoreoComponent } from './home/monitoreo/monitoreo.component';
import { MonitoreoHeatmapComponent } from './home/monitoreo/monitoreo-heatmap/monitoreo-heatmap.component';
import { MonitoreoSubtipoHeatmapComponent } from './home/monitoreo/monitoreo-subtipo-heatmap/monitoreo-subtipo-heatmap.component';
import { MonitoreoAlarmasComponent } from './home/monitoreo/monitoreo-alarmas/monitoreo-alarmas.component';
import { CampanaAdminStatsComponent } from './home/campana-admin/campana-admin-stats/campana-admin-stats.component';
import { CampanaAdminTableComponent } from './home/campana-admin/campana-admin-table/campana-admin-table.component';
import { ConfigAgenteComponent } from './home/config-zona/config-agente/config-agente.component';
import { RepoAlarmaInfructuosaComponent } from './home/repo-alarma-infructuosa/repo-alarma-infructuosa.component';
import { CruceSgoComponent } from './home/cruce-sgo/cruce-sgo.component';
import { ReporteZonaComponent } from './home/reporte-zona/reporte-zona.component';
import { ReportedispDistritoComponent } from './home/reporte-zona/reportedisp-distrito/reportedisp-distrito.component';
import { ReportedispCorregimientoComponent } from './home/reporte-zona/reportedisp-corregimiento/reportedisp-corregimiento.component';
import { ReportedispTecnicoComponent } from './home/reporte-zona/reportedisp-tecnico/reportedisp-tecnico.component';
import { FibProactivosComponent } from './home/fib-proactivos/fib-proactivos.component';
import { BitacoraProactivosComponent } from './home/bitacora-proactivos/bitacora-proactivos.component';
import { PxaComponent } from './home/pxa/pxa.component';
import { PxaDialogComponent } from './home/pxa/pxa-dialog/pxa-dialog.component';
import { PxaSimuladorComponent } from './home/pxa/pxa-simulador/pxa-simulador.component';
import { PxaAuditoriaComponent } from './home/pxa/pxa-auditoria/pxa-auditoria.component';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CampanaComponent,
    CreatecampanaComponent,
    ModifyCampanaComponent,
    CreateScheduleComponent,
    CreateAlarmaComponent,
    EjeComponent,
    CreateEjeComponent,
    TipologiaComponent,
    CreateTipologiaComponent,
    RolComponent,
    CreateRolComponent,
    AgenteComponent,
    CreateAgenteComponent,
    AsignarCampanaComponent,
    CreateCriterioComponent,
    CreateCicloComponent,
    ReasignacionModalComponent,
    ConfiguracionComponent,
    RazonAlarmaComponent,
    CreateRazonComponent,
    DashboardComponent,
    EntrevistaComponent,
    CreateEntrevistaComponent,
    DistribuidorComponent,
    CreateDistribuidorComponent,
    ClienteDuplicadoComponent,
    AutorizarCampanaComponent,
    DlgCampanaComponent,
    DlgCampanaDetailComponent,
    MensajeriaMasivaComponent,
    CreateMensajeriaComponent,
    ConfigBlacklistComponent,
    CreatePruebaComponent,
    AreaComponent,
    CreateAreaComponent,
    AdministradorComponent,
    CreateAdministradorComponent,
    DuplicarCampanaComponent,
    ScheduleCitasComponent,
    ConfigContrataComponent,
    CampanaAdminComponent,
    CreateCampanaComponent,
    TipificacionRecolectorComponent,
    CreateTipificacionComponent,
    EquipoRecolectadoComponent,
    VerImgComponent,
    RecolectorEquiposComponent,
    CreateRecolectorEquiposComponent,
    AdminAgenteComponent,
    CrudAgenteComponent,
    EditContratasComponent,
    CitasProgramadasComponent,
    CitasSuspendidasComponent,
    DlgCitaprogramComponent,
    DlgEditarCuentaComponent,
    DlgFiltersComponent,
    ReporteCitaComponent,
    ReporteFallapersisteComponent,
    MapaCitaComponent,
    MapaCitaFiltersComponent,
    MapaCitaAlarmasTableComponent,
    SupervisorAdminComponent,
    CreateSupervisorAdminComponent,
    ConfigZonaComponent,
    ConfigDistritoComponent,
    ConfigCorregimientoComponent,
    EdificioComponent,
    CreateEdificioComponent,
    MapaTecnicoComponent,
    MonitoreoComponent,
    MonitoreoHeatmapComponent,
    MonitoreoSubtipoHeatmapComponent,
    MonitoreoAlarmasComponent,
    CampanaAdminStatsComponent,
    CampanaAdminTableComponent,
    ConfigAgenteComponent,
    RepoAlarmaInfructuosaComponent,
    CruceSgoComponent,
    ReporteZonaComponent,
    ReportedispDistritoComponent,
    ReportedispCorregimientoComponent,
    ReportedispTecnicoComponent,
    FibProactivosComponent,
    BitacoraProactivosComponent,
    PxaComponent,
    PxaDialogComponent,
    PxaSimuladorComponent,
    PxaAuditoriaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    routes,
    HttpClientModule,
    TranslateModule.forRoot(),
    TooltipModule.forRoot(),
    // SharedModule re-exports MaterialModule, FormsModule, ReactiveFormsModule, FlexLayoutModule,
    // NgxSpinnerModule, PipesModule, ColorPickerModule, NgScrollbarModule, PickerModule,
    // MatButtonToggleModule, MatBadgeModule, NgxMatSelectSearchModule, TooltipModule,
    // AngularFontAwesomeModule, NgxEditorModule, AngularEditorModule
    SharedModule,
    // SupervisorModule is eagerly loaded (components shared with /home routes)
    SupervisorModule,
  ],
  entryComponents: [
    CreatecampanaComponent,
    ModifyCampanaComponent,
    CreateScheduleComponent,
    CreateAlarmaComponent,
    CreateEjeComponent,
    CreateTipologiaComponent,
    CreateRolComponent,
    CreateAgenteComponent,
    CreateCriterioComponent,
    CreateCicloComponent,
    ReasignacionModalComponent,
    ConfiguracionComponent,
    CreateRazonComponent,
    DlgCampanaComponent,
    CreateMensajeriaComponent,
    CreateEntrevistaComponent,
    CreateDistribuidorComponent,
    CreatePruebaComponent,
    CreateAreaComponent,
    CreateAdministradorComponent,
    DuplicarCampanaComponent,
    ConfigContrataComponent,
    CreateCampanaComponent,
    CreateTipificacionComponent,
    VerImgComponent,
    CreateRecolectorEquiposComponent,
    CrudAgenteComponent,
    EditContratasComponent,
    DlgCitaprogramComponent,
    DlgEditarCuentaComponent,
    DlgFiltersComponent,
    CreateSupervisorAdminComponent,
    CreateEdificioComponent,
    PxaDialogComponent,
    PxaSimuladorComponent,
    PxaAuditoriaComponent,
  ],
  exports: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: "es-GT" },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    LocalSaveService,
    LoginService,
    ComponentPageTitle,
    Handle,
    ComponentTabController,
    UploadServiceService,
    CustomizerService,
    FiltroPaisService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
